import qs from 'qs';
import { newAPI } from '../../../../../../services';

export const createCharge = async params => {
  const response = await newAPI.put(`/${params.userId}/establishment/${params.establishmentId}/clients/${params.clientId}/charge`, qs.stringify(params));
  return response.data;
}